import module from './module.js'
// Components
import './components/component.js'
import './components/balance/component.js'
import './components/bancos/component.js'
import './components/footer/component.js'
import './components/idioma/component.js'
import './components/informacion/component.js'
import './components/informacion/contacto/component.js'
import './components/informacion/direccion/component.js'
import './components/informacion/sat/component.js'
import './components/informacion/sat/enviardeducciones/component.js'
import './components/informacion/segurosocial/component.js'
import './components/informacionclientes/component.js'
import './components/nominas/component.js'
import './components/preferencias/component.js'
import './components/servicios/component.js'
import './components/soporte/component.js'
import './components/soporte/agregar/component.js'
// Routes
import './routes/guest.js'
import './routes/guest/balance.js'
import './routes/guest/bancos.js'
import './routes/guest/informacion.js'
import './routes/guest/informacionclientes.js'
import './routes/guest/nominas.js'
import './routes/guest/preferences.js'
import './routes/guest/servicios.js'
import './routes/guest/soporte.js'
import './routes/guest/informacion/contacto.js'
import './routes/guest/informacion/direccion.js'
import './routes/guest/informacion/sat.js'
import './routes/guest/informacion/segurosocial.js'
// Services
import './services/Guest.js'
import './services/Guest/Balance.js'
import './services/Guest/Cuentas.js'
import './services/Guest/Idioma.js'
import './services/Guest/Informacion/Contacto.js'
import './services/Guest/Informacion/Direccion.js'
import './services/Guest/Informacion/Personal.js'
import './services/Guest/Informacion/Sat.js'
import './services/Guest/Informacion/Sat/Deducciones.js'
import './services/Guest/Informacion/SeguroSocial.js'
import './services/Guest/Nominas.js'
import './services/Guest/Nomina/Documento/Cfdi.js'
import './services/Guest/Nomina/Documento/Comprobante.js'
import './services/Guest/Nomina/Documento/Recibo.js'
import './services/Guest/Nomina/Documento/Tirilla.js'
import './services/Guest/Servicios.js'
import './services/Guest/Soporte.js'

export default module.name



// WEBPACK FOOTER //
// ./src/guest/index.js